var map = {
	"./components/screens/FormScreen.vue": 820,
	"./components/screens/HowtoScreen.vue": 36,
	"./components/screens/IntroScreen.vue": 153,
	"./components/screens/MainScreen.vue": 905,
	"./components/screens/QuestionScreen.vue": 751,
	"./components/screens/ResultScreen.vue": 230,
	"./components/screens/VideoScreen.vue": 479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;